<script setup lang="ts">
import { BlockTileBannerFull } from '~/lib/services/content/content.blocks.dtos'

const props = defineProps<{
  block: BlockTileBannerFull
}>()

const isMobile = useIsMobile()
const isTablet = useIsTablet()

const backgroundColor = computed(() => {
  return props.block.backgroundColor === 'yellow' ? 'bg-mcd-main' : 'bg-white'
})
const buttonColor = computed(() => {
  return props.block.backgroundColor === 'yellow'
    ? 'bg-mcd-black text-white hover:bg-slate-600 hover:text-white'
    : 'bg-mcd-main'
})

const changePartial = computed(() => {
  const backgroundColorPosition =
    props.block.imagePosition === 'left' ? 'lg:flex-row' : 'lg:flex-row-reverse'
  const image = props.block.imagePosition === 'left' ? 'lg:left-[68px]' : 'lg:right-[68px] '
  return { image, backgroundColorPosition }
})
</script>
<template>
  <section class="flex w-full justify-center">
    <div
      :class="{
        'lg:flex-row-reverse': block.imagePosition === 'right',
        'lg:flex-row': block.imagePosition === 'left',
        'lg:w-10/12': !block?.isShownWide,
        'lg:w-full': block?.isShownWide,
        backgroundColor,
      }"
      class="mt-8 flex w-full flex-col lg:mt-20 lg:flex-row lg:shadow-lg"
    >
      <figure
        v-if="block.imageType === 'imageFull'"
        class="max-h-[450px] w-full md:max-h-[800px] lg:h-full lg:w-5/12"
      >
        <img
          class="h-full w-full object-cover"
          :src="isMobile ? block.imageMobile.url : block.imageDesktop.url"
          :alt="
            (isMobile ? block.imageMobile.alternativeText : block.imageDesktop.alternativeText) ||
            undefined
          "
        />
      </figure>

      <!-- TODO: PARTIAL -->
      <div
        v-else
        :class="changePartial.backgroundColorPosition"
        class="h-[332px] lg:flex lg:h-[420px] lg:w-1/2"
      >
        <figure class="relative h-[300px] bg-mcd-main lg:h-full lg:w-11/12 lg:py-[68px]">
          <img
            :class="changePartial.image"
            class="absolute right-0 top-12 h-full w-11/12 object-cover sm:w-[492px] lg:top-auto lg:h-[285px] lg:w-[492px]"
            :src="isMobile || isTablet ? block.imageMobile.url : block.imageDesktop.url"
            :alt="
              (isMobile || isTablet
                ? block.imageMobile.alternativeText
                : block.imageDesktop.alternativeText) || undefined
            "
          />
        </figure>
      </div>

      <aside
        :class="backgroundColor"
        class="flex flex-col gap-10 px-4 py-8 lg:w-7/12 lg:justify-center lg:px-16"
      >
        <header class="flex flex-col gap-4">
          <h2 class="text-[32px] font-bold leading-9 tracking-[-0.15px]">{{ block.title }}</h2>
          <CustomRichText
            class="text-sm leading-4 tracking-[-0.15px] lg:text-lg lg:leading-6"
            :transform-text="block.content"
          />
        </header>
        <footer v-if="block.primaryBtn" class="flex items-start">
          <SimpleLink :link="block.primaryBtn">
            <McdButton :class="buttonColor" is-primary class="h-10 w-full min-w-[149px]">
              {{ block.primaryBtn?.title }}
            </McdButton>
          </SimpleLink>
        </footer>
      </aside>
    </div>
  </section>
</template>
